import { defineComponent as _defineComponent } from 'vue'
import { BTableColumn } from 'buefy/dist/esm/table';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { Tag } from '@/ui/components';
  import { Button } from '@/ui/components/Button';
  import { t } from '@/ui/i18n/i18n';
  import { router } from '@/ui/routes';
  import { AiPhotoValidationListItem } from '@/entities/aiPhotoValidation';
  import { imageUrl } from '@/services/assets-api/assetsClient';
  import { download, toasted } from '@/ui/helpers';
  import { useAiPhotoValidationHelpers } from './useAiPhotoValidationHelpers';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiPhotoValidationList',
  props: {
    records: {
      type: Array as () => AiPhotoValidationListItem[],
      required: true,
    },
  },
  setup(__props) {

  // @ts-ignore
  

  const handleDownload = (e: Event, assetId: string) => {
    e.stopPropagation();
    try {
      const url = new URL(imageUrl(assetId));
      download(url);
    } catch (error) {
      toasted.error(t('ai-photo-validation.download-error'));
    }
  };

  const { formatDate, formatConfidence, getValidationResultLabel } = useAiPhotoValidationHelpers();

  const handleRowClick = (row: AiPhotoValidationListItem) => {
    router.push({
      name: 'aiPhotoValidationDetail',
      params: {
        id: row.id.toString(),
      },
    });
  };

  const getValidationResultTagType = (result: boolean | null): 'success' | 'error' => {
    return result === true ? 'success' : 'error';
  };

return { __sfc: true,handleDownload, formatDate, formatConfidence, getValidationResultLabel, handleRowClick, getValidationResultTagType, BTableColumn, ResourceTable, Tag, Button }
}

})